export default __webpack_public_path__ + "static/media/Logo.94a15f0f.jpg";